<template>
    <div>
        <div class="flex-row mt-3 animated fadeIn transparente">
            <div class="container">
                <b-row class="justify-content-center">
                    <b-col sm="9" md="9" lg="9" xl="5">
                        <b-card-group>
                            <b-card no-body class="p-0 pb-3">
                                <b-card-body class="pb-0">
                                    <div class="text-center">
                                        <img
                                            src="img/logo-login.png"
                                            alt="app-logo"
                                            class="mb-4"
                                        />
                                        <!-- <h2>{{ appNome }}</h2> -->
                                        <h4>{{ appDescr }}</h4>
                                        <h5 class="mb-4 text-muted">
                                            ESQUECI MINHA SENHA
                                        </h5>
                                        <!-- <span>{{ appDescr }}</span> -->
                                        <!-- <br /> -->
                                    </div>
                                    <app-erros-box
                                        :erros="erros"
                                        v-if="erros.length > 0"
                                    ></app-erros-box>
                                    <p class="text-muted">
                                        Informe os dados abaixo
                                    </p>
                                    <b-row>
                                        <b-col sm="12">
                                            <b-form-group>
                                                <label class="required"
                                                    >CPF</label
                                                >
                                                <b-form-input
                                                    type="text"
                                                    maxlength="14"
                                                    v-model="cpf"
                                                    @input="$v.cpf.$touch()"
                                                    :state="
                                                        $v.cpf.$error
                                                            ? false
                                                            : null
                                                    "
                                                    v-mask="'###.###.###-##'"
                                                ></b-form-input>
                                                <b-form-invalid-feedback
                                                    >O CPF do usuário é
                                                    obrigatório</b-form-invalid-feedback
                                                >
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="12">
                                            <b-form-group>
                                                <label class="required"
                                                    >E-mail</label
                                                >
                                                <b-form-input
                                                    type="text"
                                                    v-model="email"
                                                    @input="$v.email.$touch()"
                                                    :state="
                                                        $v.email.$error
                                                            ? false
                                                            : null
                                                    "
                                                ></b-form-input>
                                                <b-form-invalid-feedback
                                                    >Forneça um email
                                                    válido</b-form-invalid-feedback
                                                >
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <div
                                        class="d-flex justify-content-center mt-4"
                                    >
                                        <vue-recaptcha
                                            ref="recaptcha"
                                            @verify="onCaptchaVerified"
                                            @expired="onCaptchaExpired"
                                            :sitekey="recaptchaSiteToken"
                                            :loadRecaptchaScript="true"
                                            language="pt-BR"
                                            v-if="recaptchaSiteToken"
                                        ></vue-recaptcha>
                                    </div>
                                    <div
                                        class="d-flex justify-content-center mt-4"
                                    >
                                        <b-button
                                            variant="danger"
                                            @click.stop="voltar()"
                                            class="mr-2"
                                        >
                                            <span>
                                                <i class="fa fa-history"></i>
                                                Voltar
                                            </span>
                                        </b-button>
                                    </div>
                                    <b-row>
                                        <b-col>
                                            <div class="mt-4 text-center">
                                                <span>
                                                    <strong
                                                        >v{{ versao }}</strong
                                                    >
                                                </span>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </b-card-body>
                            </b-card>
                        </b-card-group>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators'
import LoginServicos from './LoginServicos'
import VueRecaptcha from 'vue-recaptcha'
import axios from 'axios'

export default {
    name: 'Login',
    components: {
        'vue-recaptcha': VueRecaptcha
    },

    data() {
        return {
            cpf: '',
            email: '',
            erros: [],
            versao: process.env.VUE_APP_VERSION,
            recaptchaSiteToken: null,
            recaptchaToken: '',
            appNome: process.env.VUE_APP_NOME,
            appDescr: process.env.VUE_APP_DESCR
        }
    },

    beforeCreate() {
        this.$store.dispatch('verificarVersao')
        axios.get('app/recaptcha.txt').then(res => {
            this.recaptchaSiteToken = res.data.trim()
        })
    },

    mounted() {},

    methods: {
        voltar() {
            this.$router.push({ name: 'Login' })
        },

        onCaptchaVerified(recaptchaToken) {
            this.recaptchaToken = recaptchaToken
            this.solicitarNovaSenha()
        },

        onCaptchaExpired() {
            this.$refs.recaptcha.reset()
        },

        solicitarNovaSenha() {
            this.$store.dispatch('addRequest')
            let esqueciMinhaSenhaDto = {
                cpf: this.cpf.apenasNumeros(),
                email: this.email.toLowerCase(),
                recaptchaToken: this.recaptchaToken
            }
            LoginServicos.solicitarNovaSenha(esqueciMinhaSenhaDto).then(
                data => {
                    if (data) {
                        if (data.success) {
                            this.solicitacaoRealizadaComSucesso()
                        } else {
                            this.erros[0] = 'Erro ao processar sua solicitação.'
                        }
                    }
                    this.$store.dispatch('removeRequest')
                    this.$refs.recaptcha.reset()
                }
            )
        },

        solicitacaoRealizadaComSucesso() {
            this.$swal({
                title: 'Solicitação de nova senha realizada com sucesso',
                html: `Se as informações fornecidas estiverem corretas
                você receberá um email com uma nova senha provisória para acesso ao ESPAÇO DO FORNECEDOR.`,
                icon: 'success'
            }).then(result => {
                this.$router.push('/')
            })
        }
    },

    validations: {
        cpf: {
            required,
            cpfValido(value) {
                return this.$cpfValido(value.apenasNumeros())
            }
        },
        email: {
            required,
            email
        }
    }
}
</script>
